import { notUndefined } from './notUndefined.util'

/**
 * @description Checks whether or not str can be converted into JSON
 * @param {String} str
 */
export const isJSONFormat = str => {
    if (!notUndefined(str)) return false

    try {
        JSON.parse(str)
        return true
    } catch (err) {
        return false
    }
}

/**
 * @param {String} data 
 * @returns Parsed object
 */
export const deserialize = (data) => isJSONFormat(data) ? JSON.parse(data) : {}